import React from 'react';
import {
    Typography,
    Box,
    Grid,
    IconButton,
    Divider,
    Paper,
    Badge,
    useTheme,
    Chip,
} from '@mui/material';
import { Edit, FormatListBulleted } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../../utils/TimeFormat';
import { getImageUrlAdminToken } from '../../utills/ImagesUtilsAdmin';

const CompetitionCard = ({ competition }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const {
        competition_id,
        competition_name,
        competition_start_date,
        competition_end_date,
        enrollment_start_date,
        enrollment_end_date,
        module,
        status,
        tracking_attribute,
        tracking_window,
        criteria_function,
        competition_prize_details,
        banner,
        participant_count,
    } = competition;

    const statusConfig = {
        ongoing: { color: 'success', label: 'Ongoing' },
        upcoming: { color: 'warning', label: 'Upcoming' },
        ended: { color: 'info', label: 'Ended' }
    };

    const { color: statusColor, label: statusLabel } = statusConfig[status.toLowerCase()] || { color: 'primary', label: status };



    return (
        <Paper elevation={0} sx={{ borderRadius: 2, height: '100%', position: 'relative' }}>

            <Box
                onClick={() => navigate(`/competitions/${competition_id}/participants`)}
                component="img"
                src={getImageUrlAdminToken(banner)}
                alt={`${competition_name} Banner`}
                sx={{ width: '100%', height: 160, objectFit: 'cover', borderTopLeftRadius: 8, borderTopRightRadius: 8, cursor: 'pointer' }}
            />

            <Chip
                label={statusLabel}
                color={statusColor}
                sx={{
                    position: 'absolute',
                    top: 12,
                    left: 12,
                    fontWeight: 600,
                    backgroundColor: theme.palette[statusColor]?.main,
                }}
                clickable={false}
                onClick={(e) => e.stopPropagation()}
            />


            <Grid container spacing={1} p={1}>
                <Grid size={9}>
                    <Typography variant="h6" fontWeight={600} sx={{ cursor: 'pointer' }} onClick={() => navigate(`/competitions/${competition_id}/participants`)}>
                        {competition_name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Module: {module}
                    </Typography>
                </Grid>

                <Grid size={3} justifyContent="flex-end" display="flex" alignItems="flex-start" gap={1}>
                    <Badge color="primary" overlap="circular"
                        badgeContent={participant_count}
                    >
                        <IconButton
                            onClick={() => navigate(`/competitions/${competition_id}/participants`)}
                            sx={{
                                bgcolor: theme.palette.background.default,
                            }}
                        >
                            <FormatListBulleted />
                        </IconButton>
                    </Badge>
                    <IconButton
                        onClick={() => navigate(`/competition/${competition_id}/edit`)}
                        sx={{
                            bgcolor: theme.palette.background.default,
                        }}
                        disabled={competition.status === 'inactive'}
                    >
                        <Edit />
                    </IconButton>
                </Grid>

                <Grid size={6}>
                    <Box
                        sx={{
                            bgcolor: theme.palette.background.default,
                            px: 1.5,
                            py: 1,
                            borderRadius: 2,
                        }}
                    >
                        <Typography variant="body2" fontWeight={600}>
                            Competition Date
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {formatDate(competition_start_date)} - {formatDate(competition_end_date)}
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={6}>
                    <Box
                        sx={{
                            bgcolor: theme.palette.background.default,
                            px: 1.5,
                            py: 1,
                            borderRadius: 2,
                        }}
                    >
                        <Typography variant="body2" fontWeight={600}>
                            Submission Date
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {formatDate(enrollment_start_date)} - {formatDate(enrollment_end_date)}
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={12}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                        <Typography variant="body2">
                            <strong>Tracking Attribute:</strong> {tracking_attribute || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Tracking Window:</strong> {tracking_window || 'N/A'}
                        </Typography>

                        <Typography variant="body2">
                            <strong>Criteria Function:</strong>
                            <Typography component={"span"} variant="body2" sx={{ textTransform: 'uppercase' }}> {criteria_function.slice(0).replace('_', ' ') || '-'}</Typography>
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={12}>
                    <Divider sx={{ mb: 1.5 }} />
                    <Typography variant="body2">
                        <strong>Prize:</strong> {competition_prize_details}
                    </Typography>
                </Grid>

            </Grid>
        </Paper>
    );
};

export default CompetitionCard;
